import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { AppService } from '../app.service';
import { HttpClientService } from '@flysas/httputil';

@Injectable()
export class HttpService {

  public oAuthToken: string = sessionStorage.getItem('oAuthToken');

  constructor(private http: HttpClientService, private appService: AppService) {
  }

  public getData(request): Observable<any> {
    return this.http.getData(request);
  }

  public getHtml(url): Observable<any> {
    return this.http.getHtml(url);
  }

  public postData(request): Observable<any> {
    return this.http.postData(request);
  }
}
